import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/userAgreement',
    name: 'userAgreement',
    component: () => import(/* webpackChunkName: "about" */ '../views/UserAgreement.vue'),
  },
  {
    path: '/privacyAgreement',
    name: 'privacyAgreement',
    component: () => import(/* webpackChunkName: "about" */ '../views/PrivacyAgreement.vue'),
  },
  {
    path: '/tPrivacyAgreement',
    name: 'tPrivacyAgreement',
    component: () => import(/* webpackChunkName: "about" */ '../views/TPrivacyAgreement.vue'),
  },
  {
    path: '/vipAgreement',
    name: 'vipAgreement',
    component: () => import(/* webpackChunkName: "about" */ '../views/VipAgreement.vue'),
  }
  ,
  {
    path: '/PayAgreement',
    name: 'PayAgreement',
    component: () => import(/* webpackChunkName: "about" */ '../views/PayAgreement.vue'),
  }
  ,
  {
    path: '/AiUserAgreement',
    name: 'AiUserAgreement',
    component: () => import(/* webpackChunkName: "about" */ '../views/AiUserAgreement.vue'),
  }
  ,
  {
    path: '/SdkPrivacy',
    name: 'SdkPrivacy',
    component: () => import(/* webpackChunkName: "about" */ '../views/SdkPrivacy.vue'),
  }
]


const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
